
import { useEffect, useState } from 'preact/hooks'
import { isClient } from '@util/env'


function replaceQuery(name, value) {
    const searchParams = new URLSearchParams(window.location.search)
    const hasValue = !(value === undefined || value === null)
	
	if (hasValue) searchParams.set(name, value)
	if (!hasValue) searchParams.delete(name)
    
    const query = searchParams.toString()
    const newLocation = window.location.pathname + (query ? '?' + query : '')
    
    history.replaceState(null, '', newLocation)
    const replaceEvent = new CustomEvent('replaceState', {
        detail: { location: newLocation }
    })
    window.dispatchEvent(replaceEvent)
}

export function useQueryString(name) {

	if (!isClient) return [null, () => {}]

	const getQuery = () => new URL(window.location.href).searchParams.get(name)

	const [value, setValue] = useState(getQuery())

	const updateQuery = value => {
		replaceQuery(name, value)
		setValue(value)
	}

	useEffect(() => {
		const update = () => setValue(getQuery())
		window.addEventListener('replaceState', update)
		return () => window.removeEventListener('replaceState', update)
	})

	return [value, updateQuery]
}

